import { useLingui } from '@lingui/react/macro';

import { Item } from './Item';

export const ArticleDistributorWarrantyExtension = () => {
  const { t } = useLingui();

  return (
    <Item
      label={t({
        id: 'article.information.distributor-warranty-extension.label',
        message: 'Extension',
      })}
      value={t({
        id: 'article.information.distributor-warranty-extension.activated',
        message: 'Activated',
      })}
    />
  );
};
